<template>
  <a-card title="当前泊位使用情况">
    <div style="padding: 4px 0">
      <a-table
        row-key="parkingLotId"
        table-layout="fixed"
        :data-source="slotList.list"
        :columns="columns"
        :loading="loading"
        :pagination="false"
        :scroll="{ y: 500 }"
        bordered
      >
      </a-table>
    </div>
    <a-pagination
      v-model:current="page"
      v-model:page-size="pageSize"
      :total="total"
      :show-total="total => `${total}条数据`"
      @change="currentChange"
    >
    </a-pagination>
  </a-card>
</template>

<script>
import useDashboard from "@/hooks/useDashboard";
import { onMounted, ref } from "vue";
import { slotNum } from "@/api/dashboardApi";
import useMessage from "@/hooks/useMessage";
import usePagination from "@/hooks/usePagination";

export default {
  name: "AnalysisTag",
  setup() {
    const loading = ref(false);
    const { showErr } = useMessage();
    const { slotList } = useDashboard();
    const total = ref("0")
    const { page, pageSize, currentChange, doQuery, doRefresh } =
      usePagination(loadData);

    const columns = [
      {
        title: "序号",
        align: "center",
        width: "80px",
        customRender: ({ index }) => {
          return index + 1;
        },
      },
      {
        title: "车场",
        align: "center",
        dataIndex: "parkingLotName",
      },
      {
        title: "泊位数",
        align: "center",
        dataIndex: "totalSlotNum",
      },
      {
        title: "当前在停数",
        align: "center",
        dataIndex: "parkingSlotNum",
      },
      {
        title: "空闲泊位数",
        align: "center",
        dataIndex: "freeSlotNum",
      }
    ];


    onMounted(async () => {
      loadData();
    });

    const loadData = async (page, pageSize) => {
      loading.value = true;
      try {
        let r = await slotNum(page, pageSize);
        slotList.list = r.data;
        total.value = r.total
        loading.value = false;
      } catch (e) {
        loading.value = false;
        showErr(e);
      }
    };

    return {
      columns,
      loading,
      slotList,
      total,
      page,
      pageSize,
      currentChange,
      doQuery,
      doRefresh,
      loadData
    };
  },
};
</script>
